import { createFileRoute } from "@tanstack/react-router";
import { StateLocationsHub, type StateCity } from "@/components/site/StateLocationsHub";
import cincinnati__asset from "@/assets/restore/locations/cincinnati.jpg.asset.json";
import columbus__asset from "@/assets/restore/locations/columbus.jpg.asset.json";
import independence__asset from "@/assets/restore/locations/independence.jpg.asset.json";

const map = (q: string) =>
  `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(q)}`;

const cities: StateCity[] = [
  {
    name: "Cincinnati",
    address: "300 E. Business Way, Suite 200",
    img: cincinnati__asset.url,
    mapUrl: map("300 E Business Way Cincinnati OH"),
    to: "/locations/ohio/cincinnati/",
  },
  {
    name: "Columbus",
    address: "100 E. Campus View Boulevard, Suite 250",
    img: columbus__asset.url,
    mapUrl: map("100 E Campus View Boulevard Columbus OH"),
    to: "/locations/ohio/columbus/",
  },
  {
    name: "Independence",
    address: "6100 Oak Tree Boulevard, Suite 200",
    img: independence__asset.url,
    mapUrl: map("6100 Oak Tree Boulevard Independence OH"),
    to: "/locations/ohio/independence/",
  },
];

export const Route = createFileRoute("/locations/ohio/")({
  head: () => ({
    meta: [
      { title: "Ohio Hair Transplants | RESTORE® Hair" },
      {
        name: "description",
        content:
          "RESTORE® Hair in Ohio. Book a free personal hair loss consultation at our Cincinnati, Columbus, and Independence locations.",
      },
      { property: "og:title", content: "Ohio Hair Transplants | RESTORE® Hair" },
      {
        property: "og:description",
        content:
          "See RESTORE® Hair locations across Ohio and book a free consultation.",
      },
      { property: "og:url", content: "https://restorehair.com/locations/ohio/" },
    ],
    links: [{ rel: "canonical", href: "https://restorehair.com/locations/ohio/" }],
  }),
  component: () => <StateLocationsHub stateName="Ohio" cities={cities} />,
});